document.addEventListener("DOMContentLoaded", function() {
  // Calificación con estrellas
  const starElements = document.querySelectorAll('.custom-review-stars .stars');
  
  starElements.forEach(function(stars) {
    const ratingValue = parseFloat(stars.parentElement.querySelector('.rating-value').textContent);
    const fullStars = Math.floor(ratingValue);  // Número de estrellas llenas
    const fraction = ratingValue % 1;  // Fracción de la estrella

    stars.querySelectorAll('.star').forEach(function(star, index) {
      if (index < fullStars) {
        star.classList.add('filled');  // Llena la estrella completamente
      } else if (index === fullStars && fraction > 0) {
        star.classList.add('partial');  // Estrella fraccionada
        star.style.setProperty('--fraction', `${fraction * 100}%`);  // Ajusta el ancho de la fracción
      } else {
        star.classList.add('empty');  // Estrellas vacías
      }
    });
  });

  // Contador numérico
  const counters = document.querySelectorAll('.counter-number');

  counters.forEach(function(counter) {
    const target = +counter.getAttribute('data-target'); // Valor final del contador
    const duration = +counter.getAttribute('data-time') * 1000; // Duración dinámica en milisegundos
    const interval = 50; // Intervalo de actualización del contador en milisegundos
    const totalSteps = duration / interval; // Número total de pasos
    const increment = Math.ceil(target / totalSteps); // Incremento por cada paso
    
    let currentValue = 0;

    function updateCounter() {
      currentValue += increment;
      
      // Si se llega al final del conteo, muestra el número en formato simplificado
      if (currentValue >= target) {
        currentValue = target;
        counter.textContent = formatCounter(currentValue);
      } else {
        counter.textContent = currentValue; // Mostrar el valor actual del conteo
        setTimeout(updateCounter, interval); // Continuar el conteo
      }
    }

    // Iniciar el conteo
    updateCounter();
  });

  // Función para formatear el valor del contador
  function formatCounter(value) {
    if (value >= 1000000) {
      return Math.floor(value / 1000000) + 'M+'; // Millones (M+)
    } else if (value >= 1000) {
      return Math.floor(value / 1000) + 'K+'; // Miles (K+)
    } else if (value >= 100) {
      return Math.floor(value / 100) + 'C+'; // Centenas (C+)
    } else {
      return value;
    }
  }
});
